module.exports = __webpack_public_path__ + "h5/img/tongji(1)@3x.21954684.png";